import { Datagrid, DateField, List, NumberField, ReferenceField, TextField } from 'react-admin';
import { MyDateInput } from '../constant/MyDateInput';

export const View_rekap_jadwalList = () => (
    <List filters={piketFilters} filterDefaultValues={{"tahun_bulan": new Date().toLocaleDateString("en-CA", {year:"numeric", month: "2-digit"})}}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="nama" />
            {/* <ReferenceField label="Nama Petugas" source="id" reference="petugas_pst" link={false} >
                <TextField source="nama" />
            </ReferenceField> */}
            <NumberField source="jumlah_total" />
            <TextField source="tahun_bulan" />
        </Datagrid>
    </List>
);

const piketFilters = [
    // <SearchInput source="tanggal" alwaysOn />,
    <MyDateInput source="tahun_bulan" parse={val => val.substring(0,7)} alwaysOn />,
    // <DateInput source="tanggal" parse={val => getStringFromDate(val).substring(0,10)} inputFormat="dd MMMM yyyy" alwaysOn />,
];